export default "__VITE_ASSET__BFi2_RCo__"